import { useMutation, useQuery } from '@tanstack/react-query';
import { checkBaseIntegrity, fixBaseIntegrity } from '@teable/openapi';
import { Button, Popover, PopoverContent, PopoverTrigger } from '@/ui-lib/shadcn';
import { Check, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const IntegrityButton = () => {
  const { t } = useTranslation(['table']);

  const { data, isLoading, refetch } = useQuery({
    queryKey: ['baseIntegrity', 'bse0'],
    queryFn: () => checkBaseIntegrity().then(({ data }) => data),
    enabled: false,
  });

  const { mutateAsync: fixIntegrity } = useMutation({
    mutationFn: () => fixBaseIntegrity(),
    onSuccess: () => {
      refetch();
    },
  });

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button size="xs" variant="outline" onClick={() => refetch()}>
          Check Integrity
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80">
        {isLoading ? (
          <div className="flex items-center justify-center py-2">
            <Loader2 className="size-6 animate-spin" />
            <span className="ml-2">{t('table:table.integrity.loading')}</span>
          </div>
        ) : (
          <div className="py-2">
            {data?.hasIssues ? (
              <>
                {data?.linkFieldIssues?.[0]?.baseName && (
                  <div className="mb-2 font-medium">{data.linkFieldIssues[0].baseName}</div>
                )}
                {data?.linkFieldIssues?.map((issues, index) => (
                  <div key={index} className="mb-2 ml-4 text-sm">
                    {issues.issues.map((issue) => (
                      <div key={issue.type}>
                        <div>Type: {issue.type}</div>
                        <div>Message: {issue.message}</div>
                      </div>
                    ))}
                  </div>
                ))}
                <Button onClick={() => fixIntegrity()} size="sm" className="mt-2">
                  {t('table:table.integrity.fixIssues')}
                </Button>
              </>
            ) : (
              <div className="flex items-center justify-center py-2">
                <Check className="size-6 text-green-500" />
                <span className="ml-2 text-green-500">{t('table:table.integrity.allGood')}</span>
              </div>
            )}
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
};
